// Tab audio capture is supported here only on desktop Google Chrome.
export function supportsMeetingCapture() {
  return typeof navigator !== 'undefined'
    && /Chrome\//.test(navigator.userAgent)
    && !/Android|Mobile|Edg\/|OPR\//.test(navigator.userAgent)
    && typeof navigator.mediaDevices?.getDisplayMedia === 'function';
}
